import {Phone} from 'lucide-react'
import React from 'react'

interface Props {
  message: any
  theme?: 'light' | 'dark'
}

const formatDuration = (ms: number) => {
  const totalSeconds = Math.max(0, Math.round(ms / 1000))
  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60
  if (hours > 0) {
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
  }
  return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
}

const CallSummaryCard: React.FC<Props> = ({message, theme = 'light'}) => {
  const title = message?.title || 'Voice Call Ended'
  const durationMs = typeof message?.durationMs === 'number' ? message.durationMs : 0
  const endedAt = message?.endedAt ? new Date(message.endedAt) : null

  return (
    <div
      className='call-summary-card mb-3'
      style={{
        userSelect: 'none',
        WebkitUserSelect: 'none',
        outline: 'none',
        padding: 12,
        borderRadius: 8,
        background: theme === 'dark' ? 'rgba(255,255,255,0.03)' : '#fafafa',
        border:
          theme === 'dark' ? '1px solid rgba(255,255,255,0.04)' : '1px solid rgba(16,24,40,0.06)',
        width: '100%',
        minWidth: 240,
      }}
      role='status'
      aria-live='polite'
      aria-label={`${title}. Duration ${formatDuration(durationMs)}`}
    >
      <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
        <div
          style={{
            width: 44,
            height: 44,
            borderRadius: 8,
            background: theme === 'dark' ? 'rgba(255,255,255,0.04)' : '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Phone size={20} color={theme === 'dark' ? '#9ca3af' : '#0ea5e9'} />
        </div>
        <div style={{flex: 1}}>
          <div style={{fontWeight: 700, marginBottom: 4}}>{title}</div>
          <div style={{display: 'flex', flexDirection: 'column', gap: 4, alignItems: 'flex-start'}}>
            <div style={{fontSize: 13, color: 'var(--bs-text-muted)'}}>
              <strong>Duration:</strong>&nbsp;{formatDuration(durationMs)}
            </div>
            {endedAt && (
              <div style={{fontSize: 12, color: 'var(--bs-text-muted)'}}>
                Ended at {endedAt.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default CallSummaryCard
